class MyDetailsController {
  constructor (UserService, ValidationRules, I18n) {
    'ngInject'
    this.userService = UserService
    this.validationRules = ValidationRules
    this.I18n = I18n
    this.isProcessing = true
    this.civilities = this.validationRules.civility
    this.updatePassword = {}
    this.isValidOldPassword = true
    this.isWrongOldPassword = false
    this.loaded = this.init()
  }

  init () {
    return this.userService.getCurrentUser()
    .then((user) => {
      this.user = user

      let deleteCivility = true
      this.civilities.forEach((civility) => {
        if (this.user.civility === civility.id) {
          deleteCivility = false
        }
      })

      if (deleteCivility) {
        delete this.user.civility
      }

      this.userDetails = this.buildDetails()
      this.isProcessing = false
    })
  }

  buildDetails () {
    const userDetails = Object.assign({}, this.user)
    if (userDetails.address) {
      const addressLines = userDetails.address.split('\n')
      userDetails.address1 = addressLines[0]
      userDetails.address2 = addressLines[1]
      userDetails.address3 = addressLines[2]
      delete userDetails.address
    }
    return userDetails
  }

  get userPayload () {
    const user = Object.assign({}, this.userDetails)
    if (user.address1) {
      user.address = [user.address1, user.address2, user.address3].join('\n')
      delete user.address1
      delete user.address2
      delete user.address3
    }
    return user
  }

  updateUserDetails (userDetails) {
    return this.userService.update(this.userPayload)
    .then((user) => {
      this.user = user
      this.userDetails = this.buildDetails()
      return Promise.resolve(user)
    }, (err) => {
      return Promise.reject(err)
    })
  }

  changePassword () {
    return this.userService.changePassword(this.updatePassword.oldPassword, this.updatePassword.newPassword)
    .then((success) => {
      this.updatePassword = {}
      return Promise.resolve(success)
    }, (err) => {
      this.error = err
      if (this.error.data.meta.code === 524) {
        this.errorCode = this.error.data.meta.code
      }
      if (this.error.data.meta.statusCode === 403) {
        this.isWrongOldPassword = true
      }
      return Promise.reject(err)
    })
  }

  /**
   * validate old password
   * it should be match with old password patter or with checkPassword WS
   * @returns {boolean}
   */
  validateOldPassword () {
    this.isValidOldPassword = true
    if (this.updatePassword.oldPassword && this.updatePassword.oldPassword.length >= 8 && this.updatePassword.oldPassword.length <= 32) {
      let isMatchOldPattern = this.updatePassword.oldPassword.match(this.validationRules.password.pattern)
      if (isMatchOldPattern === null) {
        this.userService.checkPassword(this.updatePassword.oldPassword).then((valid) => {
          this.isValidOldPassword = true
          return Promise.resolve()
        }, (err) => {
          this.isValidOldPassword = false
          return Promise.reject(err)
        })
      }
    }
    return this.isValidOldPassword
  }

  cancelAddressForm () {
    if (this.user.address) {
      const addressLines = this.user.address.split('\n')
      this.userDetails.address1 = addressLines[0]
      this.userDetails.address2 = addressLines[1]
      this.userDetails.address3 = addressLines[2]
    }
    this.userDetails.zipCode = this.user.zipCode
    this.userDetails.city = this.user.city
  }

}

export default MyDetailsController



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/my-details/my-details.controller.js